import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestModel } from '@models/index';

/**
 * HttpApiService builds the GET 
 * and POST HTTP requests and send 
 * them to an API
 */
@Injectable({
    providedIn: 'root'
})

export class HttpApiService {

    /**
     * HttpApiService constructor
     * @param http Injectable class with methods to perform HTTP requests. 
     * Each request method has multiple signatures, and the return type depends
     * on the called signature.
     */
    constructor(
        private http: HttpClient
    ) { }

    /**
     * Performs a HTTP GET Request to the
     * API path
     * @param data Path where HTTP GET petiton will be
     * requested
     * @returns An observable with the HTTP response
     * body. The body parameters will depend on
     * the specific request
     */
    getRequest(data: RequestModel): Observable<Object> {
        return this.http
            .get(encodeURI(`${environment.apiPath}/${data.params}`))
    }

    /**
     * Performs a HTTP POST Request to the
     * API path
     * @param data Includes the path where HTTP POST
     * petiton will be requested and the payload body 
     * to be posted
     * @returns An observable with the HTTP response
     * body. The body parameters will depend on
     * the specific request
     */
    postRequest(data: RequestModel): Observable<Object> {
        return this.http
            .post(`${environment.apiPath}/${data.params}`, data.payload)
    }

    /**
    * Performs a HTTP GET Request to the
    * API path
    * @param data Path where HTTP GET petiton will be
    * requested
    * @returns An observable with the HTTP response
    * body. The body parameters will depend on
    * the specific request
    */
    getRequestOctetStream(data: RequestModel): Observable<Blob> {
        return this.http
            .get(encodeURI(`${environment.apiPath}/${data.params}`), {
                responseType:"blob"
            })
    }
}